import React from 'react';
import { Modal } from 'antd';
import './styles.css';
import { useLocation } from 'react-router-dom';
import map_fr from '../../assets/video/fr/sm_fr.mp4';
import map from '../../assets/video/samarqand.mp4';

export const VideoModal = ({ isVideoModalOpen, setIsVideoModalOpen }) => {
  const { pathname } = useLocation();
  const isfr = pathname.includes('fr');

  const video_src = isfr ? map_fr : map;

  return (
    <Modal
      centered
      width={1000}
      title={null}
      open={isVideoModalOpen}
      onCancel={() => setIsVideoModalOpen(false)}
      footer={null}
      destroyOnClose
      className='videoModal'
    >
      <video
        onEnded={() => setIsVideoModalOpen(false)}
        poster={require('../../assets/map.png')}
        autoPlay
        width='100%'
        controls
      >
        <source src={video_src} type='video/mp4' />
        Your browser does not support HTML video.
      </video>
    </Modal>
  );
};
